<style lang="scss" scoped>
.banner-box {
    width: 100%;
    height: 480px;
}

.active-boxs {
    position: relative;
    margin-top: -60px;
    z-index: 1000;

    .list-box {
        width: 60%;
        min-width: 1000px;
        height: 120px;
        border-radius: 20px;
        box-shadow: 0px 16px 36px 0px rgba(0, 0, 0, 0.12);
        background: rgb(255, 255, 255);
        margin: 0 auto;

        .list {
            width: 288px;
            padding: 0 54px;
            text-align: center;
            position: relative;
            z-index: 10;

            // padding-top: 28px;



            &::after {
                content: "";
                display: block;
                width: 180px;
                height: 0px;
                position: absolute;
                border-radius: 12px;
                box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.16);
                background: linear-gradient(146.56deg, rgb(243, 79, 64) 1.874%, rgb(183, 37, 30) 88.193%);
                z-index: -1;
                opacity: 0;
                transition: height .3s, opacity .16s;
            }

            &:hover {

                &::after {
                    height: 152px;
                    opacity: 1;
                }

                .montserrat-text,
                .t1 {
                    color: #ffffff;
                }
            }

            .montserrat-text {
                font-size: 36px;
                font-weight: 700;
                color: #191919;
                font-style: italic;
                height: 36px;
                line-height: 36px;

                span {
                    font-style: italic;
                }
            }

            .t1 {
                font-size: 16px;
                color: rgb(89, 89, 89);
                line-height: 24px;
                margin-top: 4px;
                height: 24px;
                word-break: normal;
            }
        }
    }
}

.sign-box {
    height: 68px;
    border-radius: 8px;
    background: rgb(246, 246, 246);
    margin: 32px auto 0;
    width: 60%;
    min-width: 1000px;
    padding: 0 24px;

    .btn1 {
        min-width: 100px;
        height: 36px;
        border: 0.5px solid rgb(25, 25, 25);
        border-radius: 18px;
        padding: 0 14px;
        color: rgb(25, 25, 25);
        font-size: 14px;
        font-weight: 400;

        &:hover {
            background: #ffffff;
        }

        img {
            margin-right: 6px;
            position: relative;
            top: -2px;
        }
    }

    .btn2 {
        width: 32px;
        height: 32px;
        padding: 0;
        border: 1px solid rgb(223, 223, 223);
        border-radius: 4px;
        background: rgba(255, 255, 255, 0.35);
        margin-left: 24px;

        .iconfont {
            font-size: 20px;
            color: #909090;
        }

        &:hover {
            border: 1px solid #B7251E;

            .iconfont {
                color: #B7251E;
            }
        }


    }

    .s1 {
        color: rgb(25, 25, 25);
        font-family: "MicrosoftYaHeiSemibold";
        font-size: 20px;
        font-weight: 400;
        line-height: 24px;
        margin-left: 18px;
    }

    .s2 {
        color: rgb(25, 25, 25);
        font-size: 14px;
        line-height: 24px;
        margin-left: 24px;
    }

    .list {
        .list:first-child {
            margin-left: 0;
        }

        .li {
            margin-left: 44px;
            text-align: center;

            p {
                color: rgb(89, 89, 89);
                font-size: 12px;
                font-weight: 400;
                line-height: 16px;
                margin-top: 3px;
            }
        }
    }

}

.activity-box {
    margin-top: 80px;
    position: relative;
}

.popular-posts {
    background-color: #ffffff;
    padding-top: 80px;
    padding-left: 80px;
}

.hot-topic {
    padding-top: 80px;
    background: rgb(250, 250, 250);
}
</style>

<template>
    <div>
        <!-- banner -->
        <div class="banner-box">
            <homeBanner></homeBanner>
        </div>
        <!-- 活动数 -->

        <div class="active-boxs">
            <div class="list-box df">
                <div class="list df fdc jcc aic">
                    <span class="montserrat-text">
                        <count-to :start-val="0" :end-val="data_list.act_total_count" :duration="2000"></count-to>
                    </span>
                    <p class="t1">{{ $t("活动总数") }}</p>
                </div>
                <div class="list active df fdc jcc aic">
                    <span class="montserrat-text">
                        <count-to :start-val="0" :end-val="data_list.user_total_count" :duration="2000"></count-to>
                    </span>
                    <p class="t1">{{ $t("会员总数") }}</p>
                </div>
                <div class="list df fdc jcc aic">
                    <span class="montserrat-text">
                        <count-to :start-val="0" :end-val="data_list.post_total_count" :duration="2000"></count-to>
                    </span>
                    <p class="t1">{{ $t("帖子总数") }}</p>
                </div>
                <div class="list df fdc jcc aic">
                    <span class="montserrat-text">
                        <count-to :start-val="0" :end-val="data_list.topic_article_total_count"
                            :duration="2000"></count-to>
                    </span>
                    <p class="t1">{{ $t("精品文章") }}</p>
                </div>
            </div>
        </div>
        <!-- 签到送好礼 -->
        <div class="sign-box " v-if="showsign">
            <div class="df aic jcsb" style="height: 100%;">
                <div class="df aic">
                    <el-button class="btn1">
                        <img src="@/assets/images/icon/icon-01.png" alt="">{{ $t('签到') }}
                    </el-button>
                    <span class="s1">{{ $t('签到赢好礼') }}</span>
                    <!-- <span class="s2">{{ $t('今日已签到', { num: 121 }) }}</span> -->
                    <span class="s2">{{ $t('敬请期待') }}</span>
                </div>
                <div class="list df aic">
                    <div class="li">
                        <img src="@/assets/images/icon/icon-02.png" alt="">
                        <p>{{ $t('签到') }}</p>
                    </div>
                    <div class="li">
                        <img src="@/assets/images/icon/icon-03.png" alt="">
                        <p>{{ $t('商城') }}</p>
                    </div>
                    <div class="li">
                        <img src="@/assets/images/icon/icon-04.png" alt="">
                        <p>{{ $t('荣誉') }}</p>
                    </div>
                    <div class="li">
                        <img src="@/assets/images/icon/icon-05.png" alt="">
                        <p>{{ $t('任务') }}</p>
                    </div>
                    <el-button class="btn2" @click="showsign = false"><span
                            class="iconfont icon-cuo1"></span></el-button>
                </div>

            </div>
            <!-- <img src="@/assets/images/sign.png" alt=""> -->
        </div>


        <!-- 近期活动 -->
        <div class="activity-box">
            <homeFuture></homeFuture>
        </div>

        <!-- 热门话题 -->
        <div class="hot-topic">
            <homeTopic></homeTopic>
        </div>


        <!-- 热门帖子  -->
        <div class="popular-posts">
            <homePopular :data="data_list"></homePopular>
        </div>

    </div>
</template>
<script>

// 首页banner
import homeBanner from './components/banner.vue';
import homeFuture from './components/future.vue'
// 热门话题
import homeTopic from './components/topic.vue'
// 热门帖子

import homePopular from './components/popular.vue'
import { getcommonData } from "@api/home";
export default {

    components: { homeBanner, homeFuture, homeTopic, homePopular },
    data() {
        return {
            showsign: true,

            data_list: {
                act_total_count: 0,
                user_total_count: 0,
                post_total_count: 0,
                topic_article_total_count: 0,
            }
        }
    },
    mounted() {
        this.getData();

        // 设置默认的顶部菜单背景色
        this.$bus.$emit('changeNavbg', 'rgba(255, 255, 255, 0.2);');
        // 组件挂载后添加滚动事件监听
        window.addEventListener('scroll', this.handleScroll);

    },
    methods: {


        async getData() {
            let res = await getcommonData();
            if (res.status == 200) {
                this.data_list = res.data;

            }

        },

        handleScroll() {
            // 检查当前滚动位置
            if (window.scrollY >= 1) {
                this.$bus.$emit('changeNavbg', 'rgba(255, 255, 255, 1);');
            } else {
                this.$bus.$emit('changeNavbg', 'rgba(255, 255, 255, 0.2);');
            }
        },
    },
    beforeDestroy() {
        // 组件销毁前移除滚动事件监听
        window.removeEventListener('scroll', this.handleScroll);
    },


}

</script>
